import React from 'react';
import * as DateFns from 'date-fns';

import HourBox from './Hours/Hour';
import HourText from './Hours/HourText';
import { GAME, NUMBER_OF_WEEK_DAYS, PRACTICE, LEAGUES } from '../../../../config/constants';
import { RenderCellsPropsType, ScheduleWeekGame } from './types';
import { ScheduleEvent, SchedulePractice } from '../../../../config/commonTypes';

const RenderCells = ({ selectedWeek, selectedDate, events, setIndexAddButton }: RenderCellsPropsType) => {
  
  const weekStart = DateFns.startOfWeek(selectedWeek);
  const rows = [];
  const days = [];
  let day = weekStart;
  let dayGames = [];
  let otherGames = [];
  const isGameUserTeam = (event: ScheduleEvent) => false;
  // isGameUserTeam (event) => event.homeTeamId === user.teamId || event.visitorTeamId === user.teamId) && !event.isFuture;
  const groupGame = (game: ScheduleEvent): ScheduleWeekGame => {
    const newGame: ScheduleWeekGame = { ...game } as ScheduleWeekGame;
    const etGame = newGame.scheduledStartTimeEasern.split(':');
    const etOffset = (300 - new Date().getTimezoneOffset()) / 60;
    if(newGame.league === LEAGUES.NCAA){
      if (Number(etGame[0]) >= 0 && Number(etGame[0]) < 16) {
        newGame.groupTime = {
          group: 1,
          tzhour: Number(etGame[0])
        };
      } else if (Number(etGame[0]) >= 16 && Number(etGame[0]) < 20) {
        newGame.groupTime = {
          group: 2,
          tzhour: Number(etGame[0])
        };
      } else if (Number(etGame[0]) >= 20) {
        newGame.groupTime = {
          group: 3,
          tzhour: Number(etGame[0])
        };
      }
    }else if (Number(etGame[0]) >= 0 && Number(etGame[0]) < 16) {
      newGame.groupTime = {
        group: 1,
        tzhour: 13 + etOffset
      };
    } else if (Number(etGame[0]) >= 16 && Number(etGame[0]) < 20) {
      newGame.groupTime = {
        group: 2,
        tzhour: 16 + etOffset
      };
    } else if (Number(etGame[0]) >= 20) {
      newGame.groupTime = {
        group: 3,
        tzhour: 20 + etOffset
      };
    }
    return newGame;
  };
  for (let i = 0; i < NUMBER_OF_WEEK_DAYS; i++) {
    const cloneDay = day;
    dayGames = events.filter(event => (
      DateFns.isSameDay(new Date(event.startTime), cloneDay) && event.type === GAME && isGameUserTeam(event)
    ));
    otherGames = events.filter(event => (
      DateFns.isSameDay(new Date(event.startTime), cloneDay) && event.type === GAME && !isGameUserTeam(event)
    ));
    const dayPractices: SchedulePractice[] = events.filter(event => (
      DateFns.isSameDay(new Date(event.startTime), cloneDay) && event.type === PRACTICE
    )) as SchedulePractice[];
    const sweepArray: { index: number, time: number, open: boolean }[] = [];
    dayPractices.forEach((element, index) => {
      sweepArray.push({
        index: index,
        time: element.startTime,
        open: true
      });
      if (Math.abs(DateFns.differenceInMinutes(element.startTime, element.endTime)) <= 15) {
        const newTime = DateFns.addMinutes(new Date(element.startTime), 15);
        sweepArray.push({
          index: index,
          time: DateFns.getTime(newTime),
          open: false
        });
      } else {
        sweepArray.push({
          index: index,
          time: element.endTime,
          open: false
        });
      }
    });
    sweepArray.sort((a, b) => {
      if (a.time === b.time) {
        return +b.open - +a.open;
      }
      return a.time - b.time;
    });
    const bag = new Map();
    let MAX_Z_INDEX = 0;
    sweepArray.forEach(element => {
      if (element.open) {
        dayPractices[element.index]['z_index'] = MAX_Z_INDEX;
        bag.set(element.index, MAX_Z_INDEX);
        MAX_Z_INDEX++;
      } else {
        if (MAX_Z_INDEX - 1 === bag.get(element.index)) {
          MAX_Z_INDEX--;
        }
        bag.delete(element.index);
      }
    });
    dayGames = dayGames.map(game => groupGame(game));
    otherGames = otherGames.map(game => groupGame(game));
    days.push(
      <div
        className={`col cell2 ${
          DateFns.isSameDay(day, selectedDate) ? 'selected' : ''
        } ${i === 0 ? 'first-column' : ''}`}
        key={day.toString()}
        onMouseOver={_ => setIndexAddButton(i)}
      >
        <HourBox
          isToday={DateFns.isSameDay(day, selectedDate)}
          games={dayGames}
          otherGames={otherGames}
          practices={dayPractices}
          // print={DateFns.getDate(day) === 23}
        />
      </div>
    );
    day = DateFns.addDays(day, 1);
  }
  rows.push(
    <div className="row" key={day.toString()}>
      <HourText />
      <div className="ROSSS">
        {days}
      </div>
    </div>
  );
  
  return <>{rows}</>;
};

export default RenderCells;
